module.exports = __webpack_public_path__ + "static/media/programador.afadaa94.png";